// Capabilities lists shown below the featured Showcase on the Services page.
// Add a new capability by appending a string to the relevant array.
const moreServices = {
  services: [
    "Commercial Moving & Installation",
    "Turnkey Plant / Factory Moves, Logistics & Inventory",
    "Millwright Services",
    "Crane Rental Services",
    "Custom Rigging & Lifting Services",
    "Warehouse & Storage Facilities",
    "Container Stuffing / De-stuffing",
    "White Glove Services",
  ],
  equipment: [
    "CNC Machinery Moving",
    "HVAC Systems",
    "Bank Safes & Vaults",
    "Commercial / Industrial Kitchen Equipment",
    "Commercial Tank Moving",
    "Medical, Lab & Dental Equipment",
    "Fragile & Delicate Moving",
  ],
};

export default moreServices;
